import React from 'react';

const OccasionFilter = ({ selectedOccasion, onOccasionChange }) => {
  // Using the actual occasion constants from backend with emojis
  const occasions = [
    { id: 'birthday', emoji: '🎂', label: 'Birthday' },
    { id: 'christmas', emoji: '🎄', label: 'Christmas' },
    { id: 'valentines_day', emoji: '💝', label: "Valentine's Day" },
    { id: 'mothers_day', emoji: '🌸', label: "Mother's Day" },
    { id: 'fathers_day', emoji: '👔', label: "Father's Day" },
    { id: 'graduation', emoji: '🎓', label: 'Graduation' },
    { id: 'wedding', emoji: '💒', label: 'Wedding' },
    { id: 'housewarming', emoji: '🏠', label: 'Housewarming' },
    { id: 'baby_shower', emoji: '👶', label: 'Baby Shower' },
    { id: 'anniversary', emoji: '💑', label: 'Anniversary' },
    { id: 'retirement', emoji: '🏖️', label: 'Retirement' }
  ];

  return (
    <div>
      <h3 className="font-medium text-accent-800 mb-3 flex items-center">
        🎉 Occasion
      </h3>

      <div className="grid grid-cols-2 gap-2">
        {occasions.map((occasion) => (
          <button
            key={occasion.id}
            onClick={() => onOccasionChange(occasion.id)}
            className={`p-2 rounded-lg text-center transition-all duration-200 ${selectedOccasion === occasion.id
              ? 'border-2 border-yellow-600 bg-yellow-200 shadow-inner transform scale-95'
              : 'border-2 border-accent-200 hover:border-accent-300 bg-white hover:bg-accent-50 shadow-sm'
              }`}
          >
            <div className="text-lg mb-1">{occasion.emoji}</div>
            <div className={`text-xs ${selectedOccasion === occasion.id
              ? 'font-bold text-yellow-800'
              : 'font-medium text-accent-600'
              }`}>
              {occasion.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default OccasionFilter;